import { render, staticRenderFns } from "./ChartCard.vue?vue&type=template&id=1605b632"
import script from "./ChartCard.vue?vue&type=script&lang=js"
export * from "./ChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports